<template>
        <div id='sqbm'>
              <NavTop title='双亲积分报名'/>
              <div class="resultrow">
               <van-notice-bar color="#1989fa" background="#ecf9ff" left-icon="info-o" v-if="bminfo.status==1">
                  已提交报名申请，请耐心等待后台审核
                </van-notice-bar>
               <van-notice-bar color="#67c23a" background="#f0f9eb" left-icon="passed" v-else-if="bminfo.status==2">
                  <span>已报名成功</span>
               </van-notice-bar>
               <van-notice-bar color="#f56c6c" background="#fef0f0" left-icon="info-o" v-else-if="bminfo.status==3">
                  审核拒绝，原因:{{bminfo.msg}},请修改后重新提交
               </van-notice-bar>
             </div> 
              <div class='content'>
                <img src="http://www.cnihz.cn/static/img/sqbm.jpg" class='sqimg'/>
              </div> 
              <div class="imgrow">
                 <div class="imgcol">
                  <van-uploader :after-read="afterRead" :upload-icon="img1==''?undefined:img1" :preview-image='false' image-fit="cover" name='img_1'/>
                  <span>父亲正面</span>
                 </div>
                 <div class="imgcol">
                  <van-uploader :after-read="afterRead" :upload-icon="img2==''?undefined:img2" :preview-image='false' image-fit="cover" name='img_2'/>
                  <span>父亲反面</span>
                 </div>
                 <div class="imgcol">
                  <van-uploader :after-read="afterRead" :upload-icon="img3==''?undefined:img3" :preview-image='false' image-fit="cover" name='img_3'/>
                  <span>母亲正面</span>
                 </div>
                 <div class="imgcol">
                  <van-uploader :after-read="afterRead" :upload-icon="img4==''?undefined:img4" :preview-image='false' image-fit="cover" name='img_4'/>
                  <span>母亲反面</span>
                 </div>
              </div>
              <div class="btnrow" v-if="bminfo.status!=2">
                  <div class="sumitbtn" @click="doBm">
                      确认提交报名
                  </div>
              </div>
        </div>
</template>
<script>
import NavTop from '@/components/navtop'
import { NoticeBar, Uploader} from 'vant'
export default {
  data(){
      return{
         img1:'',
         img2:'',
         img3:'',
         img4:'',
         bminfo:{},
         processing:false
      }
  },  
  name: 'sqbm',
  created(){
     this.getList()
  },
  methods:{
     getList(){
        this.$post("/user/getSqbmInfo").then((data)=>{
               if(data.result.success){
                  this.bminfo=data.result.info
                  this.img1=this.bminfo.img1
                  this.img2=this.bminfo.img2
                  this.img3=this.bminfo.img3
                  this.img4=this.bminfo.img4
               }else{
                 this.$toast(data.result.info)
                 setTimeout(()=>{this.$go("/my")},1000)
               }
           })   
     },
     doBm(){
        if(this.processing){
           this.$toast("请等待提交完成");return false;
        }
        if(this.img1==''|| this.img1==undefined){
            this.$toast("请上传父亲身份证的正面照片");return false;
        }
        if(this.img2==''|| this.img2==undefined){
            this.$toast("请上传父亲身份证的反面照片");return false;
        }
        if(this.img3==''|| this.img3==undefined){
            this.$toast("请上传母亲身份证的正面照片");return false;
        }
        if(this.img4==''|| this.img4==undefined){
            this.$toast("请上传母亲身份证的反面照片");return false;
        }
        this.bminfo["img1"]=this.img1
        this.bminfo["img2"]=this.img2
        this.bminfo["img3"]=this.img3
        this.bminfo["img4"]=this.img4
        this.processing=true
        this.$post("/user/saveSqbm",{bminfo:this.bminfo}).then((data)=>{
           this.processing=false
           if(data.result.success){
              this.$toast(data.result.info)
              this.getList()
           }else{
              this.$toast(data.result.info)
           }
        })
     },
     afterRead(file,info) { 
      let name=info.name   
      let tag=name.split("_")
      let index=tag[1]
      const uploadImgFile=file.content
      this.$post("/uploader/headImgBase64",{type:'idcard',image:uploadImgFile}).then((data)=>{
           if(data.result.success){
               this['img'+index]=data.result.info.url 
           }
      })
    }
  },
  components:{
      NavTop,
      [NoticeBar.name]:NoticeBar,
      [Uploader.name]:Uploader
  }
}
</script>
<style scoped>
#sqbm{background-color:#fff;min-height: 100vh;padding-bottom: 0.5rem;}
.content{font-size:0.5rem;overflow-x:hidden;word-break:break-all;text-align: left;width:100%;}
.sqimg{width:100%;display: block;}
::v-deep .fixcon{margin-bottom: 0!important;}
.imgrow{display: flex;flex-flow: row;width: 100%;padding: 0 0.3rem;}
.imgcol{width:25%;display: flex;flex-flow: column nowrap;justify-content: center;font-size:0.25rem;}

.btnrow{display: flex;flex-flow: row;width: 100%;justify-content: center;align-items: center;padding: 0 0.3rem;margin-top: 0.25rem;}
.sumitbtn{width:100%;border-radius: 0.2rem;background-color: #ee0a24;color:#fff;font-size:0.38rem;height:1rem;display: flex;flex-flow: row nowrap;align-items: center;justify-content: center;}

::v-deep .van-uploader{display:flex ;justify-content: center;}
::v-deep .van-uploader__upload-icon{font-size:80px;}
::v-deep .van-uploader__upload{margin: 0;background-color: #fff;}
</style>


